import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Container,
  Card,
  Accordion,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import format from "date-fns/format";
import Header from "../../../Layouts/Header";
import BottomTab from "../../../Layouts/BottomTab";
import ItemList from "../Invoice/ItemList";
import Patient from "../Patient";
import { httpUnAuth, httpAuth } from "../../../Utils/http";
import { actionTypes } from "../../../Utils/Constants";
import Loader from "../../../Layouts/Loader";
import { toast } from "react-toastify";
import { Rating, PopupPlayer, Carousel } from "../../UI/";
import { SwiperSlide } from "swiper/react";
import styles from "./Home.module.css";

export default function Home(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [isRating, setRateMutating] = useState(false);
  const [acOpen, setAcOpen] = useState(true);
  const [invoice, setInvoice] = useState(null);
  const [rate, setRate] = useState(
    invoice && invoice.ratings ? invoice.ratings : -1
  );
  const [rated, setRated] = useState(invoice && invoice.ratings ? true : false);
  const [carousels, setCarousels] = useState([]);
  const [cards, setCards] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [popupUrl, setPopupUrl] = useState("https://bill.wellnessforever.in/api/videos/wellness.mp4");
  const [showPopup, setShowPopup] = useState(false);
  const [popupShown, setPopupShown] = useState(false);

  const [rateChangable, setRateChangable] = useState(false);

  const location = useLocation();
  const params = useParams();
  const query = new URLSearchParams(location?.search || '');
  const invoiceId = params?.invoiceId;
  const finalInvoiceId = invoiceId || query.get("q");
  console.log("Home render: location.search:", location?.search, "params:", params, "query.get('q'):", query.get("q"), "finalInvoiceId:", finalInvoiceId);

  const handleLogin = () => dispatch({ type: actionTypes.SHOW_LOGIN });

  const handleRateChange = (newRate) => {
    setRate(newRate);
  };

  const itemClicked = (item) => {
    const params = {
      type: item.ad_type,
      data: { 
        ad_id: item.ad_id, 
        ad_type: item.ad_type,
        storeId: item.storeId || null,
        campaign_id: item.campaign_id || null
      },
    };
    if (auth.token) {
      params.data.ad_customer_clicks = { customer_id: auth.username };
    }
    console.log("Recording click:", params);
    httpUnAuth.post("v1/banners/clicks", params)
      .then((res) => {
        console.log("Click recorded successfully:", res.data);
      })
      .catch((err) => {
        console.error("Error recording click:", err);
      });
    if (item.banner_type === "video") {
      setVideoUrl(item.ad_target_url);
    }
  };

  const submitRating = () => {
    if (rate < 1) return;
    if (isRating) return;
    if (invoice) {
      setRateMutating(true);
      httpUnAuth
        .post("v1/stores/ratings", {
          userId: invoice.mobile,
          storeId: invoice.storeId,
          ratings: rate,
          transactionId: invoice.id,
        })
        .then((res) => {
          setInvoice((prevInvoice) => ({
            ...prevInvoice,
            ratings: rate,
          }));
          setRated(true);
          setRateMutating(false);
          toast.success("Ratings submitted successfully");
        })
        .catch((err) => {
          console.log({ err });
          setRateMutating(false);
          toast.error("Couldn't submit rating");
        });
    }
  };

  // invoices when loggedin
  useEffect(() => {
    if (auth.token) {
      if (!finalInvoiceId) {
        httpAuth
          .get(`v1/invoices?userId=${auth.username}&perPage=1&pageNumber=1`, {
            headers: { role: "customer" },
          })
          .then((res) => {
            console.log("Invoice response:", res); // Debug log
            if (!res.data.data || res.data.data.length === 0) {
              setInvoice(null);
              setLoading(false);
              return;
            }
            console.log("Invoice data:", res.data.data[0]);
            setInvoice(res.data.data[0]);
            if (res.data.data[0].ratings === null) {
              setRateChangable(true);
            } else {
              setRate(parseInt(res.data.data[0].ratings) || -1);
              setRateChangable(false);
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
          });
      } else {
        setInvoice(null);
        setLoading(false);
      }
    }
  }, [auth.token]);

  useEffect(() => {
    setRate(invoice && invoice.ratings ? invoice.ratings : -1);
    setRated(invoice && invoice.ratings ? true : false);
  }, [invoice]);

  // carousels
  useEffect(() => {
    console.log("Fetching carousels, invoice:", invoice);
    httpUnAuth
      .get("v1/assets", {
        params: {
          type: 'carousels',
          perPage: 500, // Default perPage
          pageNumber: 1, // Default pageNumber
          enabled: true,
          date: true,
          ...(invoice && { storeId: invoice["storeId"] }),
        },
      })
      .then((res) => {
        console.log("Carousels response:", res.data);
        const carouselData = res.data.data || [];
        setCarousels(carouselData);

        // Set popup URL to campaign-specific video if available, else default
        const videoBanner = carouselData.find(item => item.banner_type === 'video');
        if (videoBanner && videoBanner.ad_media) {
          setPopupUrl(videoBanner.ad_media);
          // Show popup only once per page load
          if (!popupShown) {
            setShowPopup(true);
            setPopupShown(true);
          }
        } else {
          setPopupUrl("https://bill.wellnessforever.in/api/videos/wellness.mp4");
          // Show default popup only once per page load
          if (!popupShown) {
            setShowPopup(true);
            setPopupShown(true);
          }
        }
      })
      .catch((err) => {
        console.log("Carousels error:", err);
      });
  }, [invoice, popupShown]);

  // partner communications
  useEffect(() => {
    httpUnAuth
      .get("v1/assets", {
        params: {
          type: 'cards',
          perPage: 500, // Default perPage
          pageNumber: 1, // Default pageNumber
          enabled: true,
          date: true,
        },
      })
      .then((res) => {
        setCards(res.data.data);
      })
      .catch((err) => {});
  }, []);

  // invoice by id
  useEffect(() => {
    console.log("Invoice by id useEffect, finalInvoiceId:", finalInvoiceId, "auth.token:", auth.token);
    if (finalInvoiceId && !auth.token) {
      console.log("Calling v1/invoices/", finalInvoiceId);
      httpUnAuth
        .get(`v1/invoices/${finalInvoiceId}`, {
          headers: { role: "customer" },
        })
        .then((res) => {
          console.log("Response from v1/invoices", res.data);
          const transaction = res.data.transaction;
          if (transaction) {
            setInvoice(transaction);
            if (transaction.ratings === null) {
              setRateChangable(true);
            } else {
              setRate(parseInt(transaction.ratings) || -1);
              setRateChangable(false);
            }
          }
        })
        .catch((err) => {
          console.log("Error getting invoice by id", err);
        });
    }
  }, [finalInvoiceId, auth.token]);

  if (invoice) {
    console.log("invoice:", invoice);
    console.log("invoice.data:", invoice?.data);
    console.log("invoice.data[0]:", invoice?.data?.[0]);
    console.log("invoice.data[0].header:", invoice?.data?.[0]?.header);
    console.log("invoice.billNo:", invoice?.billNo);
    console.log("invoice.data[0].header.firmname:", invoice?.data?.[0]?.header?.firmname);
    console.log("invoice.data[0].header.billDate:", invoice?.data?.[0]?.header?.billDate);
    console.log("invoice.data[0].header.billtime:", invoice?.data?.[0]?.header?.billtime);
    console.log("invoice.totalBill:", invoice?.totalBill);
    console.log("invoice.data[0].header.totalbill:", invoice?.data?.[0]?.header?.totalbill);
    console.log("invoice.data[0].det:", invoice?.data?.[0]?.det);
    console.log("invoice.data[0].header for ItemList:", invoice?.data?.[0]?.header);
    console.log("invoice.totalBill for ItemList:", invoice?.totalBill);
    console.log("invoice.data[0].header for Patient:", invoice?.data?.[0]?.header);
    console.log("invoice.mobile:", invoice?.mobile);
  }

  return (
    <Container className="we_container">
      <Loader show={loading} />
      <PopupPlayer
        url={popupUrl}
        show={showPopup}
        onClose={() => setShowPopup(false)}
      />
      <div className={videoUrl !== "" ? "otp_modal show" : "otp_modal"}>
        <div className="opt_modal_cnt ivideo">
          <div className="line"></div>
          <Link to="#" className="close-otp" onClick={() => setVideoUrl("")}>
            <img src={process.env.PUBLIC_URL + "/image/close.svg"} alt="" />
          </Link>
          <iframe
            src={videoUrl.replace("watch?v=", "embed/")}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="video"
            width="100%"
            height="250px"
          />
        </div>
      </div>
      <Header />
      <div className="main-container">
        <Row>
          <Col>
            {invoice ? (
              <>
                <h1>
                  {"Hey, " + invoice.data[0].header.patname.split(" ")[0]}
                </h1>
                <h3>Wellness Forever 24x7 Aapke Saath</h3>
              </>
            ) : (
              ""
            )}
          </Col>
        </Row>

        {carousels.length ? (
          <Carousel carousels={carousels} itemClicked={itemClicked} hideVideos={showPopup} />
        ) : null}

        <Row className="home_transection">
          <Col>
            <Card className="home_transection_card">
              <Card.Header className="home_transection_card_hed">
                <img
                  src={process.env.PUBLIC_URL + "/image/icon-3.svg"}
                  alt=""
                />
                Recent Transaction
              </Card.Header>
              <Card.Body>
                {invoice ? (
                  <div className="mb-4" key={invoice.id}>
                    <div
                      className="home_transection_t1"
                      onClick={() => setAcOpen((prev) => !prev)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Row>
                        <Col xs="8">
                          <h2>Invoice #{invoice.billNo.split("S")[1]}</h2>
                          <p>
                            {`${invoice.data[0].header.firmname} ${invoice.data[0].header.firmaddress}`}
                          </p>
                          <p>
                            {format(
                              new Date(
                                invoice.data[0].header.billDate +
                                  " " +
                                invoice.data[0].header.billtime
                              ),
                              "dd MMM, yyyy | HH:mm "
                            )}
                            hrs
                          </p>
                        </Col>
                        <Col xs="4">
                          <strong>
                            {parseFloat(invoice.totalBill || invoice.data[0].header.totalbill).toFixed(2)}{" "}
                            <FontAwesomeIcon
                              icon={acOpen ? faChevronDown : faChevronUp}
                            />{" "}
                          </strong>
                        </Col>
                      </Row>
                    </div>
                    {acOpen && (
                      <div className="home_transection_tab mt-3">
                        <Col>
                          <Row
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "10px",
                            }}
                          >
                            <div>
                              <Rating
                                rating={rate}
                                handleRateChange={handleRateChange}
                                rateChangable={rateChangable}
                                submitRating={submitRating}
                                rated={rated}
                                isRating={isRating}
                              />
                            </div>
                          </Row>
                          <Tabs
                            defaultActiveKey="Purchases"
                            className="tab_list"
                          >
                            <Tab eventKey="Purchases" title="Purchases">
                              <ItemList
                                items={invoice.data[0].det}
                                header={invoice.data[0].header}
                                totalBill={invoice.totalBill}
                              />
                            </Tab>
                             <Tab eventKey="Patient" title="Patient Info">
                              <Patient
                                {...invoice.data[0].header}
                                mobile={invoice.mobile}
                              />
                             </Tab>
                          </Tabs>
                        </Col>
                      </div>
                    )}
                  </div>
                ) : null}
                <Row>
                  <Col className="text-center view_link view-all">
                    <Link
                      to={auth.token ? "/invoices" : "#"}
                      onClick={handleLogin}
                      style={{ fontWeight: "bold" }}
                    >
                      <b>View All Invoices</b>
                    </Link>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <h2>Partner communications</h2>
          </Col>
        </Row>
        <Row className="home_slide_2 mt-2">
          <Col>
            {cards.length ? (
              <Carousel carousels={cards} itemClicked={itemClicked} />
            ) : null}
          </Col>
        </Row>
        <Row className="mt-4 mb-4 text-center link_tearm">
          <Col>
            <a href="https://wellnessforever.com/terms">Terms and Conditions</a>
          </Col>
        </Row>
        <Row className="mt-3 footer text-center">
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <section>Powered by</section>
            <section
              style={{
                marginLeft: "1rem",
              }}
            >
              <img src={process.env.PUBLIC_URL + "/image/logo.svg"} alt="" />
            </section>
          </section>
        </Row>
      </div>
      <BottomTab />
    </Container>
  );
}
